<template lang="pug">
.container
  br
  h4.header
    span {{ $t('Alerts')}}
  .section
    .alerts.table-header
      .cell {{ $t('ID') }}
      .cell {{ $t('Message') }}
      .cell {{ $t('Created') }}
      .cell {{ $t('Updated') }}
      .cell {{ $t('Last success') }}
    .alerts.body(
      v-for="alert of alerts"
    )
      .cell(
        :class="{ warning: alert.level === 'warning', error: alert.level === 'error', notice: alert.level === 'notice' }"
      )
          | {{ alert.id }}
      .cell {{ alert.message }}
      .cell {{ humanTime(parseInt(alert.createdAt)) }}
      .cell {{ humanTime(parseInt(alert.updatedAt)) }}
      .cell {{ alert.lastSuccessAt > 0 ? humanTime(parseInt(alert.lastSuccessAt)) : '-' }}
</template>

<script>
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [textUtils],
  props: ['alerts'],
  components: {
  },
  async created () {
  },
  updated () {
  },
  watch: {
  },
  data () {
    return {
      errors: {
      }
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.header {
  display: flex;
  justify-content: space-between;
}

.alerts {
  width: 100%;
  &.hidden {
    display: none;
  }
  &.warning {
    background-color: $--color-warning;
  }
  &.error {
    background-color: $--color-danger;
  }
  &.notice {
    background-color: $--color-success;
  }
  &.table-header {
    margin-bottom: 10px;
    padding: 5px 0px 5px 0px;
    border-top: $--border-light;
    border-bottom: $--border-light;
  }
  &.body {
    margin-bottom: 10px;
    color: $--color-text-secondary;
  }
  display: flex;
  font-size: $--font-size-base;
  .cell {
    width: 25%
  }
  .cell-wider {
    width: 33%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/Alerts.vue